import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    copySubtitle:
      'Please enter your Shine secret code to copy this card number',
    revealSubtitle:
      'Please enter the Shine secret code to show this card details',
    title: 'For more security...',
  },
  fr: {
    copySubtitle:
      'Veuillez renseigner le code secret Shine pour copier les numéros de cette carte',
    revealSubtitle:
      'Veuillez renseigner le code secret Shine pour afficher les détails de cette carte',
    title: 'Pour plus de sécurité',
  },
} as const);
